"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__MQTT_STATE_PUBLISH_OPTS__ = exports.__MQTT_ACTION_PUBLISH_OPTS__ = exports.__MQTT_STATUS_EXPIRE_PUBLISH_OPTS__ = exports.__MQTT_STATUS_PUBLISH_OPTS__ = void 0;
exports.__MQTT_STATUS_PUBLISH_OPTS__ = {
    qos: 2,
    retain: true,
};
exports.__MQTT_STATUS_EXPIRE_PUBLISH_OPTS__ = {
    qos: 2,
    properties: {
        messageExpiryInterval: 60,
    },
};
exports.__MQTT_ACTION_PUBLISH_OPTS__ = {
    qos: 2,
    properties: {
        messageExpiryInterval: 60,
    },
};
exports.__MQTT_STATE_PUBLISH_OPTS__ = {
    qos: 2,
    properties: {
        messageExpiryInterval: 60,
    },
};
//# sourceMappingURL=options.js.map